import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import {
  DetailRoutines,
  Routines,
  SelectedClient,
} from '@core/interfaces/selected-client';
import { LocalStorageService } from '@core/services/local-storage.service';
import { SelectedClientService } from '@core/services/selected-client/selected-client.service';
import { AppState } from '@core/store/app.reducer';
import { Store } from '@ngrx/store';
import { DialogCloseSesionComponent } from '@shared/components/modals/dialog-close-sesion/dialog-close-sesion.component';
import { take } from 'rxjs';
import {
  MessageActivitiesNull,
  MessageRoutinesError,
  MessageRoutinesNull,
} from 'src/assets/data/errors-message';
import * as authActions from '@core/store/auth/auth.actions';
import * as shoppingActions from '@core/store/shoppingCar/shoppingCar.actions';
import * as clientsActions from '@core/store/selectClient/selectClient.actions';
import { AuthService } from '@core/services/authentication/auth.service';
import { AccessFormServiceService } from '@core/services/form/access-form-service.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-routines-detail',
  templateUrl: './routines-detail.component.html',
  styleUrls: ['./routines-detail.component.scss'],
})
export class RoutinesDetailComponent implements OnInit {
  readonly routinesMessage: string =
    'Cumple todas tus rutinas de la semana y logra tus objetivos.';
  routinesList: Routines | null = null;
  routinesListLoading: boolean = false;
  routinesMessageError: boolean = false;
  user: Array<any> | any;
  selectRoutines?: DetailRoutines;
  readonly messageClientNull = [MessageActivitiesNull];
  readonly messageError = [MessageRoutinesError];
  readonly messageRoutinesNull = [MessageRoutinesNull];
  readonly repeatArray = Array(4);
  readonly repeatArrayFormat = Array(2);
  showRoutinesList: boolean = true;
  readonly dateClients: Array<SelectedClient> = [];
  @ViewChild('drawerProfileOptions')
  sidenavProfile!: MatSidenav;
  @ViewChild(MatMenuTrigger) myMenu!: MatMenuTrigger;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.detectarMovil();
  }
  esMovil: boolean = false;

  readonly options = [
    { label: 'Inicio', link: '/main/inicio', icon: 'home' },
    { label: 'Subir pedido', link: '/main/subir-pedido', icon: 'downloads' },
    {
      label: 'Cuenta corriente',
      link: '/main/cuenta-corriente',
      icon: 'account',
    },
  ];
  readonly optionsResponsive = [
    { show: true, label: 'Inicio', link: '/main/inicio', icon: 'home' },
    {
      show: true,
      label: 'Datos del cliente',
      link: '/main/inicio',
      icon: 'storefront',
    },
    {
      show: true,
      label: 'Subir pedido',
      link: '/main/subir-pedido',
      icon: 'downloads',
    },
    {
      show: true,
      label: 'Avance de ventas',
      link: '/main/avances-ventas',
      icon: 'advance',
    },
    {
      show: true,
      label: 'Reconocimientos',
      link: '/main/reconocimientosdetalle',
      icon: 'recognitions',
    },
    {
      show: true,
      label: 'Cuenta corriente',
      link: '/main/cuenta-corriente',
      icon: 'account',
    },
    {
      show: true,
      label: 'Historial de compras',
      link: '/main/historial-compras',
      icon: 'history',
    },
    { show: true, label: 'Facturas', link: '', icon: 'bills' },
    { show: true, label: 'Aliados', link: '/main/aliados', icon: 'allies' },
     {
      show: true,
      label: 'Mis Reclamos',
      link: '/main/mis-reclamos',
      icon: 'recognitions',
    },
  ];
  labelVisible: boolean = true;
  currentMonth: string = '';
  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly selectedClientService: SelectedClientService,
    private readonly router: Router,
    public readonly dialogCloseSesion: MatDialog,
    private readonly store: Store<AppState>,
    private readonly _authService: AuthService,
    private readonly accessService: AccessFormServiceService,
    private readonly datePipe: DatePipe
  ) { this.setCurrentMonth();
    const navigation = this.router.getCurrentNavigation();
    this.routinesList = navigation?.extras?.state?.['data'] || null;
    if (this.routinesList && this.routinesList.routines) {
      this.selectRoutines = this.routinesList?.routines[0];
    }
  }

  ngOnInit() {
    this.detectarMovil();
    this.user = this.localStorageService.getItem('user');
    if (!this.routinesList) {
      // Si no hay datos pasados por el state, es una recarga de página
      this.initDataRoutines();
    }
    this.labelVisible = true;
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  readonly handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      // El usuario ha vuelto a la pantalla
      const lastFetchDate = localStorage.getItem('lastFetchDate');
      const today = new Date().toDateString();
      if (lastFetchDate !== today) {
        this.initDataRoutines();
      } else {
      }
    } else {
      // El usuario se ha movido fuera de la pantalla
    }
  };

  initDataRoutines() {
    this.routinesList = null;
    this.routinesListLoading = true;
    this.routinesMessageError = false;
    this.selectedClientService
      .getRoutinesList(this.user?.code)
      .pipe(take(1))
      .subscribe(
        (res: Routines) => {
          this.routinesList = res || null;
          this.selectRoutines = this.routinesList?.routines[0];
          localStorage.setItem('lastFetchDate', new Date().toDateString());
          this.routinesListLoading = false;
        },
        () => {
          this.routinesListLoading = false;
          this.routinesMessageError = true;
        }
      );
  }

  detailRoutines(routine: DetailRoutines) {
    this.selectRoutines = routine;
    this.showRoutinesList = false;
  }

  textLines(text: string): string[] {
    return (text ?? '').split('\n');
  }

  getLastValidIndex(activities: any[]): number {
    for (let i = activities.length - 1; i >= 0; i--) {
      if (activities[i].formatName && activities[i].formatName.trim() !== '') {
        return i;
      }
    }
    return -1; // Si no hay elementos válidos
  }
  goToUrl(url: string) {
   window.open(url, '_blank', 'noopener');
  }

  goToUrlOpen(value, routine) {
    // Verificar que todos los campos necesarios existan y no estén vacíos
    if (value?.idForm && value.idForm !== '' && value?.id && routine?.id) {
      // Crear el objeto con los tres parámetros para acceso
      const accessParams = {
        idForm: value.idForm,
        idActivity: value.id,
        idRoutine: routine.id,
      };
  
      // Permitir acceso y almacenar los parámetros
      this.accessService.allowAccess(accessParams);
  
      // Crear la URL con todos los parámetros como segmentos de la ruta
      const url = this.router.createUrlTree([
        '/formulario',
        value.idForm,
        value.id,
        routine.id
      ]).toString();
  
      window.open(url, '_blank', 'noopener');
    } else {
      // Si alguno de los parámetros falta, abrir `formatLink` si está disponible
      window.open(value?.formatLink, '_blank', 'noopener');
    }
  }
  
  backRoutines() {
    this.showRoutinesList = true;
  }
  clientSelect() {
    this.myMenu.closeMenu();
  }
  detectarMovil() {
    this.esMovil = window.innerWidth < 767;
  }
  closeProfile(event: string) {
    this.sidenavProfile.close();
    if (event === 'logout') {
      setTimeout(() => {
        this.openModalCloseSesion();
      }, 350);
    }
  }
  openProfile() {
    this.sidenavProfile.toggle();
  }
  openModalCloseSesion() {
    const dialogRef = this.dialogCloseSesion.open(DialogCloseSesionComponent, {
      width: '31rem',
      data: {},
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data?.status) {
        this.store.dispatch(authActions.unsetUser());
        this.store.dispatch(shoppingActions.unsetCar());
        this.store.dispatch(clientsActions.unsetClients());
        this._authService.logout();
      }
    });
  }
  setCurrentMonth(): string {
    const now = new Date();
    this.currentMonth = this.datePipe.transform(now, 'MMMM', undefined, 'es-PE') || 'Mes desconocido';
    
    // Convertir la primera letra a mayúscula
    if (this.currentMonth) {
      this.currentMonth = this.currentMonth.charAt(0).toUpperCase() + this.currentMonth.slice(1);
    }
  
    // Retornar el valor de currentMonth
    return this.currentMonth;
  }
}
